<template>
    <span v-if="proposal_status === 'complete' || proposal_status === 'ready'">
        <v-btn
        fab 
        small
        color="grey lighten-5"
        class="mx-2"
        elevation=0
        @click="downloadProposalPDF(detail)"        
        >
            <v-icon color="primary" large>mdi-download</v-icon>
        </v-btn>
        <v-tooltip top>
            <template v-slot:activator="{ on }">
                <v-btn
                    fab 
                    small
                    color="grey lighten-5"
                    class="mx-2"
                    v-on="on"
                    elevation=0
                    @click="downloadProposalDOCX(detail)"
                >
                    <v-icon color="primary" large>mdi-file-document-edit-outline</v-icon>
                </v-btn>
            </template>
            <span>Download Editable Template</span>
        </v-tooltip>    
    </span>
    <v-btn fab small color="grey lighten-5" class="mx-2" elevation=0 v-else-if="proposal_status === 'error'">
        <v-icon color="red" large>mdi-alert-circle-outline</v-icon>
    </v-btn>
    <v-tooltip top v-else>
        <template v-slot:activator="{ on }">
    <v-progress-circular indeterminate class="mr-2" v-on="on"></v-progress-circular>
        </template>
        <span>Generating Proposal PDF</span>
    </v-tooltip>
</template>

<script>
  import axios from 'axios';
  import {mapActions} from 'vuex';
  export default {
    
    data: () => ({
       proposal_status: '',
       intervalCreated: false,
       interval: null,
    }),  
      
    props: {
        status: [String],
        id: [ Number, String],
        detail: [Object],
    },
    
    mounted () {
        this.proposal_status = this.status;
    },
    
    beforeDestroy() {
        this.removeInterval();
    },
    
    watch: {
        proposal_status: {
            handler: function(new_value) {
                console.log(new_value);
                if(new_value !== "complete" && new_value != "error" && new_value !== 'ready'){
                    this.createInterval();
                } else {
                    this.removeInterval();
                }
            }
        }
    },
    methods: {
        ...mapActions(['downloadProposalPDF', 'checkQueue', 'downloadProposalDOCX']),
        
        createInterval(){
            console.log('createInterval')
            if(!this.intervalCreated){
                this.queueCheck();
                this.interval = setInterval(() => {
                    this.queueCheck()
                }, 3000);
            }
            this.intervalCreated = true;
        },
        
        queueCheck() {
            let token = sessionStorage.getItem('token');
            let authToken = "Token "+token;
            let authHeader = {headers: {
                Authorization: authToken
            }};
            axios.get('proposal/queue/?proposal_id='+ this.id, authHeader).then((res) => {
                this.proposal_status = res.data.queue_status
            })
            .catch(err => {
                console.log(err)
                this.proposal_status = 'error'
            })
        },
        removeInterval(){
            this.intervalCreated = false;
            clearInterval(this.interval);
        },
        uuidv4() {
          return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
          });
        }
    },
    components: {}
  };
</script>

<style type="text/css" scoped>
    .border {
      border-style: solid !important;
    }
    .v-data-table__expanded__content{
        box-shadow: none;
    }
    .row_item {
        border-bottom: thin solid rgb(0,0,0,30%);
    }
    .v-progress-circular__overlay {
        color: grey;
    }
</style>